"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("../..");
function Badge({ children, className, testId, }) {
    return (react_1.default.createElement("div", { "data-testid": testId, className: `capitalize w-fit flex items-center justify-center py-1 px-2 rounded-[14px] bg-green-200 ${className}` },
        react_1.default.createElement(__1.Text, { type: __1.TextType.LOZENGE }, children)));
}
exports.Badge = Badge;
//# sourceMappingURL=Badge.js.map